import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertProps } from "@mui/material/Alert";

export interface NotificationState {
  open: boolean;
  message: string;
  severity: AlertProps["severity"];
}

type ISetNotification = Partial<
  Pick<NotificationState, "message" | "severity">
>;

const initialState: NotificationState = {
  open: false,
  message: "",
  severity: "info",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    closeNotification(state) {
      state.open = false;
    },
    setNotification(state, action: PayloadAction<ISetNotification>) {
      state.open = true;
      if (action.payload.message !== undefined) {
        state.message = action.payload.message;
      }
      if (action.payload.severity !== undefined) {
        state.severity = action.payload.severity;
      }
    },
  },
});

export const { closeNotification, setNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
